/*
    Domain should only contain small letters and - . _ as well as numbers
*/
export function domainRule(
  message = "Darf nur Kleinbuchstaben enthalten und . enthalten. Keine Sonderzeichen, Keine großbuchstaben, keine Zahlen"
): (value: any) => boolean | string {
  const url = RegExp(/^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/);

  return value => url.test(value) || message;
}

export function domainOptionalRule(
  message = 'Darf nur Kleinbuchstaben und "." enthalten. Keine Sonderzeichen, keine Großbuchstaben, keine Zahlen.'
): (value: any) => boolean | string {
  const url = RegExp(/^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}$/);

  return value => url.test(value) || value == "" || message;
}
